import { LocationSearchProvider } from '../providers/locationSearchProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_MY_LOCATION_BY_IP = new AsyncAction('GET_MY_LOCATION_BY_IP');
export const LOCATION_SEARCH_BY_SEARCH_STRING = new AsyncAction('LOCATION_SEARCH_BY_SEARCH_STRING');
export const LOCATION_SEARCH_STARTED = 'LOCATION_SEARCH_STARTED';
export const LOCATION_SEARCH_TEXT_CHANGED = 'LOCATION_SEARCH_TEXT_CHANGED';
export const LOCATION_SEARCH_ENDED = 'LOCATION_SEARCH_ENDED';
export const SEARCH_LOCATION_SELECTED = 'SEARCH_LOCATION_SELECTED';
export const SET_LOCATION_SUGGESTION_INDEX = 'SET_LOCATION_SUGGESTION_INDEX';
export const CLEAR_LOCATION_SEARCH_SUGGESTIONS = 'CLEAR_LOCATION_SEARCH_SUGGESTIONS';

export function getUsersLocation(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_MY_LOCATION_BY_IP.base,
        payload: getUserLocationByIPAction(paramsObject)
    };
}

async function getUserLocationByIPAction({ baseUrl, authId, secret, stdParameters, verbose, refresh }) {
    const op = new LocationSearchProvider(baseUrl, authId, secret);
    return await op.getUserLocationByIP(stdParameters, verbose, refresh);
}

export function searchLocationBySearchString(...params) {
    let paramsObject = {
        searchString: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        maxResults: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: LOCATION_SEARCH_BY_SEARCH_STRING.base,
        payload: searchLocationBySearchStringAction(paramsObject)
    };
}

async function searchLocationBySearchStringAction({ searchString, baseUrl, authId, secret, stdParameters, verbose, refresh, maxResults }) {
    const op = new LocationSearchProvider(baseUrl, authId, secret);
    return await op.searchLocation(searchString, stdParameters, verbose, refresh, maxResults);
}

export const locationSearchStarted = () => ({
    type: LOCATION_SEARCH_STARTED
});

export const locationSearchTextChanged = (searchText) => ({
    type: LOCATION_SEARCH_TEXT_CHANGED,
    payload: searchText
});

export const locationSearchEnded = () => ({
    type: LOCATION_SEARCH_ENDED
});

export const searchLocationSelected = (location) => ({
    type: SEARCH_LOCATION_SELECTED,
    payload: location
});

export function setLocationSuggestionIndex(increment) {
    return {
        type: SET_LOCATION_SUGGESTION_INDEX,
        payload: { increment }
    };
}

export function clearLocationSearchSuggestions() {
    return {
        type: CLEAR_LOCATION_SEARCH_SUGGESTIONS
    };
}
